module.exports = __webpack_public_path__ + "img/63.4be2708a.jpg";